import { gql } from '@apollo/client';
const MOVE_MODEL_FOLDER = gql `
  mutation MoveModelFolder($modelSpecificationId: ID!, $modelSpecificationFolderId: ID!) {
    changeModelSpecificationFolder(
      modelSpecificationId: $modelSpecificationId
      modelSpecificationFolderId: $modelSpecificationFolderId
    ) {
      modelSpecification {
        id
        archivedAt
        itemCode
        folder {
          id
          name
          modelSpecificationsCount
        }
        season {
          name
        }
        state
        projections {
          edges {
            node {
              picture
            }
          }
        }
        componentsCount
        sizes {
          edges {
            node {
              id
              isActive
              sizeName {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
export default MOVE_MODEL_FOLDER;
